//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'openGoldenCardRetentionDialog',
    props: {
        value: Boolean,
    },
    data() {
        return {
            show: this.value,
        }
    },
    watch: {
        show() {
            this.$emit('input', this.show)
        },
        value() {
            this.show = this.value
        },
    },
    mounted() {
        this.sensorsRecord("h5_element_imp", {
            tgt_event_id: "h5_paycash_pjk_retention_dialog",
            tgt_name: "h5-paycash-还款确认页-拍金卡挽留弹窗曝光",
            url: location.href,
            page: "还款-确认还款页",
        });
    },
    methods: {
        joinMember() {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_pjk_retention_join",
                tgt_name: "h5-paycash-还款确认页-拍金卡挽留弹窗-加入会员",
                url: location.href,
                page: "还款-确认还款页",
            });
            this.$emit('joinMember')
        },
        leave() {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_pjk_retention_leave",
                tgt_name: "h5-paycash-还款确认页-拍金卡挽留弹窗-放弃会员",
                url: location.href,
                page: "还款-确认还款页",
            });
            this.$emit('leave')
        }
    }
}
